export const EDIT_KNOWLEDGE_CATEGORY = "EDIT_KNOWLEDGE_CATEGORY"
export const EDIT_KNOWLEDGE_CATEGORY_SUCCESS = "EDIT_KNOWLEDGE_CATEGORY_SUCCESS"
export const EDIT_KNOWLEDGE_CATEGORY_CLEAN = "EDIT_USER_CLEAN"
export const EDIT_KNOWLEDGE_CATEGORY_ERROR = "EDIT_KNOWLEDGE_CATEGORY_ERROR"
